import gql from 'graphql-tag'

export const createEditBarcodeSheet = gql`
  mutation CreateEditBarcodeSheet(
    $id: ID
    $accountId: Int!
    $width: Float!
    $height: Float!
    $size: String!
    $unit: String!
    $topMargin: Float!
    $bottomMargin: Float!
    $leftMargin: Float!
    $rightMargin: Float!
    $rows: Int!
    $columns: Int!
    $rowGutter: Float!
    $columnGutter: Float!
    $name: String!
  ) {
    createEditBarcodeSheet(
      input: {
        id: $id
        accountId: $accountId
        name: $name
        width: $width
        height: $height
        size: $size
        unit: $unit
        topMargin: $topMargin
        bottomMargin: $bottomMargin
        leftMargin: $leftMargin
        rightMargin: $rightMargin
        rows: $rows
        columns: $columns
        rowGutter: $rowGutter
        columnGutter: $columnGutter
      }
    ) {
      barcodeSheet {
        id
        accountId
        name
        size
        width
        height
        topMargin
        bottomMargin
        leftMargin
        rightMargin
        rows
        columns
        rowGutter
        columnGutter
        unit
        labels(accountId: $accountId) {
          id
          accountId
          barcodeSheetId
          name
          width
          height
          elements
        }
      }
      errors
    }
  }
`
